// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function never(_: never) {}
